import styled from "styled-components";

export const Container = styled.div`
  padding: 2rem 0.5rem 0.2rem 0.5rem;
`;
